<template>
  <div class="models">
    <headerComponent @closeUpload="closeUploadWindow"></headerComponent>
    <div class="container position-relative mb-3">
      <div class="row">
        <div class="col-lg-4 col-12">
          <sidebarComponent></sidebarComponent>
        </div>
        <div class="col-lg-8 col-12">
          <div class="row">
            <!--<div class="col-12 text-center mb-4">
               <h1>MODELS LIST</h1> 
            </div> -->
            <div class="col-12 mb-3">
              <div id="search-div" class="search-tags">
                <div class="row mb-2">
                  <div class="col-12 d-inline-flex apply-template">
                    <button class="buttons button-trial" @click="activateTrial()" :disabled="trialActivated">Free Business Trial</button>
                    <span class="d-inline-flex me-2 align-items-center trial-text" v-if="trialLeftDays>0"> {{ trialLeftDays }} days left</span>
                    <span class="d-inline-flex me-2 align-items-center trial-text" v-else></span>
                  
                    <span class="d-inline-flex me-2 align-items-center subscription-badge" v-if="subscription.data.subscription_type<=0"><i class="fa-solid fa-user"></i></span>
                    <span class="d-inline-flex me-2 align-items-center subscription-badge" v-if="subscription.data.subscription_type==1"><i class="fa-solid fa-user-tie"></i></span>
                    <span class="d-inline-flex me-2 align-items-center subscription-badge" v-if="subscription.data.subscription_type==2"><i class="fa-solid fa-building-user"></i></span>
                    <span class="d-inline-flex me-2 align-items-center subscription-badge" v-if="subscription.data.subscription_type==8"><i class="fa-solid fa-user-ninja"></i></span>
                  </div>

                  <div class="col-12">
                    <div class="tags-list">
                      <div v-if="statTotalSpace && statUsedSpace">
                        <span
                          v-if="subscription.data.subscription_type!==0"
                          @click="toggleSpaceView"
                          style="cursor:pointer;"
                          title="Click to switch between % and GB"
                          >
                          Space available:
                          <strong class="ms-1">
                            <template v-if="showSpaceInPercentage">
                              {{ (100 - (statUsedSpace / statTotalSpace) * 100).toFixed(2) }}%
                            </template>
                            <template v-else>
                              {{ ((statTotalSpace - statUsedSpace) / (1024 * 1024 * 1024)).toFixed(2) }} GB
                            </template>
                          </strong>
                        </span>                   
                        <span >Models uploaded: <strong class="ms-1">{{statNumModels}}</strong></span>
                        <span v-if="subscription.data.subscription_type==0 && statNumModels>=10" >10 models limit reached</span>  
                      </div>  
                    </div>
                  </div>
                  
                  <div class="col-12 search-bar">
                    <input type="text" v-model="modelName" class="form-control col-6 me-2" placeholder="Search by name" @keyup.enter="getModelsList()">
                    <button class="buttons button-two search-logo" @click="getModelsList()">
                      <img :src="searchLogo" />  
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="tags-list" v-if="tagsList">
                      <span @click="filterByTag('')" :class="{'active':'' == modelTag}">All</span><span :class="{'active':tag == modelTag}" v-for="tag,index in tagsList" :key="index" @click="filterByTag(tag)">{{tag}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <div class="row align-items-center">
                <div class="col-lg-6 d-flex flex-nowrap mb-lg-0 mb-3 aling-items-stretch table-selections">
                  <span class="d-inline-flex me-2 align-items-center" style="font-size:14px">Posts per page:</span>
                  <select v-model.number="perPage" class="form-select d-inline-block">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span class="line-action" type="button" @click="selectAll">Select all</span>
                  <span class="line-action" type="button" @click="deselectAll">Deselect all</span>
                </div>
                <div class="col-lg-6 d-flex flex-nowrap">
                  <button id="export-csv-id" class="buttons button-one d-inline-flex justify-content-center align-items-center export-csv" @click="showExportOptions()">Export CSV</button>
                  <button id="apply-template-id" class="buttons button-two d-inline-flex apply-template" @click="applyTemplate()">Apply template</button>
                  <button id="delete-models-id" class="buttons button-two d-inline-flex delete-models" @click="deleteAll()">Delete</button>
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-4 mb-2 align-items-strech" v-if="Object.keys(dataList).length && tableDataLoaded">

            <div class="col-lg-4 col-md-6 col-12 p-1 d-flex align-items-stretch" v-for="data,index in dataList" :key="index">
              <div class="card card-list mb-1 w-100">       
                  <div class="card-body" :id="'model-'+index" @contextmenu="onContextMenu($event,data)">
                  <div class="square-image position-relative" :style="{'background-image':`url(${data.thumbnail}),url(${thumbnailBg})`}" v-if="data.thumbnail">
                    <div class="check-button" @click="data.checked = !data.checked">
                      <img :src="checked" v-if="data.checked" class="checked-image" />
                      <img :src="unchecked" v-else  class="checked-image"/>
                      <span>Select</span>
                    </div>
                  </div>

                  <div class="square position-relative" v-else>
                    <!-- background image -->
                    <div class="check-button" @click="data.checked = !data.checked">
                      <img :src="checked" v-if="data.checked" class="checked-image" />
                      <img :src="unchecked" v-else  class="checked-image"/>
                      <span>Select</span>
                    </div>
                  </div>
                  <div class="card-title">
                    <h3>{{data.modelName}}</h3>
                  </div>
                  <div class="card-text">
                    <strong>Size:</strong><br>
                    {{formatBytes(data.modelSize)}}
                  </div>
                  <div class="card-text mt-4 mb-2">
                    <button @click="onRowClick(data)" class="buttons button-two">View more</button>
                  </div>

                </div>
              </div>
            </div>
            
          </div>
          <div class="row mt-4 mb-2 align-items-strech" v-else>
            <div class="col-12 d-flex align-items-stretch">
              <div class="void-list-models w-100" style='text-align: center;'>
                <i class='fa-solid fa-upload' style='font-size:90px;margin-top:40px;'></i>
                <div style="margin-top:50px;margin-bottom:100px;">There are no models in your account, upload at least one to get started <br> or check out our learn section</div>              
              </div>
            </div>
          </div>
          
          <div class="d-flex justify-content-center mb-3 mt-3" v-if="Object.keys(dataList).length && tableDataLoaded">
            <Pagination v-model="page" :records="statNumModels" :per-page="perPage" @paginate="onPageChange" :options="optionsPagination"/>
          </div>

        </div>
      </div>
      

    <div class="card view-model position-fixed export-csv-data-modal" style="width: 18rem;" v-if="exportOptions">
      <button type="button" class="btn-close" aria-label="Close" @click="exportOptions = false"></button>
      <div class="card-body">
        <button class="buttons button-two button-full-width mt-1 mb-1" @click="exportModels('all')">Export all models</button>
        <button class="buttons button-two button-full-width mt-1 mb-1" @click="exportModels('this')">Export this page models</button>
      </div>
    </div>   

    </div>
    <div class="loader" v-if="!loaded">
      <div>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <div class="overlay" v-if="showModal || exportOptions"></div>
    <footerComponent></footerComponent>
  </div>
  <v-tour name="myTour" :steps="steps" :options="{ highlight: true }" :callbacks="myCallbacks"></v-tour>
  <v-tour name="myTour2" :steps="steps2" :options="{ highlight: true }" :callbacks="myCallbacks2"></v-tour>

  <context-menu v-model:show="showContextMenu" :options="optionsContextMenu">
    <context-menu-item label="Copy URL" @click="onMenuClick(modelDataContextMenu)" />
    <context-menu-item label="View" @click="onMenuClickView(modelDataContextMenu)" />
    <context-menu-item label="Edit Settings" @click="onMenuClickEdit(modelDataContextMenu)" />    
    <!-- <context-menu-item v-if="!notValidCommentsExt.includes(fileExt)" label="Comments" @click="onMenuClickComments(modelDataContextMenu)" />   -->
  </context-menu>



</template>

<script>
import sidebarComponent from '../components/Sidebar.vue'
import Pagination from 'v-pagination-3';
import commonProps from '../common/common.js'
import headerComponent from '../components/Header.vue'
import footerComponent from '../components/Footer.vue'
import searchLogo from '../assets/search.svg'
import unchecked from '../assets/unchecked.svg'
import checked from '../assets/checked.svg'
import '@/assets/scss/models-list.scss'
import thumbnailBg from "@/assets/thumbnail-bg-500.png";
//import axios from 'axios'
const common = new commonProps()
import axios from 'axios'
export default {
  name:'models-list',
  components: {
    headerComponent,
    sidebarComponent,
    footerComponent,
    Pagination
  },
  data() {
    return {
      allSelected:false,
      loaded:false,
      modelName:'',
      modelTag:'',
      tagsList:[],
      searchLogo:searchLogo,
      tableDataLoaded:false,
      uploadRequest:false,
      dataList: [],
      perPage:10,
      page:1,
      exportCSV:'',
      exportOptions:false,
      optionsPagination:{
        chunk:2
      },
      checked:checked,
      unchecked:unchecked,
      //stats details
      statTotalUsers:0,
      statTotalSpace:0,
      statUsedSpace:0,
      statusedUsers:0,
      statNumModels:0,
      trialActivated:true,
      showTrial:true,
      trialLeftDays:0,
      subscription:{data:{subscription_type:0}},
      thumbnailBg,
      showModal:false,
      productTour1Done:false,
      steps: [
          {
            target: '.upload-button',
            content: 'Upload your first model',
            params: {
              placement: 'bottom',
              enableScrolling: false  
            }
          },
          {
            target: '.button-trial',
            content: 'Free Business 14 days trial activated',
            params: {
              placement: 'bottom',
              enableScrolling: false  
            }
          },
          {
            target: '.sidebar',
            content: 'View your model list and access your account and billing details',
            params: {
              placement: 'bottom',
              enableScrolling: false 
            }          
          }
      ],
      myCallbacks: {
        onSkip: this.stopProductTour,
        onFinish: this.stopProductTour
       },
      steps2: [
          {
            target: '#model-0',
            content: 'Click on View more to access the model details (View, Comment, Share, ...)',
            params: {
              placement: 'top',
              enableScrolling: false  
            }
          },
          {
            target: '#search-div',
            content: 'Search your models by name or tag',
            params: {
              placement: 'bottom',
              enableScrolling: false 
            }
          },
          {
            target: '#export-csv-id',
            content: 'Export your model details as CSV',
            params: {
              placement: 'bottom',
              enableScrolling: false 
            }
          },
          {
            target: '#apply-template-id',
            content: 'Change the 3D settings of the selected models',
            params: {
              placement: 'bottom',
              enableScrolling: false 
            }
          },
          {
            target: '#delete-models-id',
            content: 'Delete the selected models',
            params: {
              placement: 'bottom',
              enableScrolling: false 
            }
          }            
      ],
      myCallbacks2: {
        onSkip: this.stopProductTour2,
        onFinish: this.stopProductTour2
      },
      showContextMenu: false,
      optionsContextMenu: {
        zIndex: 999,
        minWidth: 230,
        x: 500,
        y: 200
      },
      modelDataContextMenu:{},
      fileExt:'',   
      notValidCommentsExt: [
        "dxf",
        "dwg"
      ],
      showSpaceInPercentage: true
    }
  },
  mounted() {
    this.getModelsList()
    this.getTagsList()
    this.getSubscription()
    this.checkProductTour()     
  },
  watch: {
    perPage: function() {
      this.page=1 //restrat from page 1 when changing perPage
      this.getModelsList()
    },
    dataList: function(){
      this.checkProductTour2()
    }
  },
  methods: {
    /**
     * tags search function
     */
    selectAll() {
      this.allSelected = true
      for (let el in this.dataList) {
        this.dataList[el].checked = true;
      }
    },
    deselectAll() {
      this.allSelected = false
      for (let el in this.dataList) {
        this.dataList[el].checked = false;
      }
    },
    filterByTag(tag) {

      this.modelTag = tag

      this.getModelsList()
    },
    getTagsList() {
      axios .get(`${common.supervisorApi}models/get_tags_list/`)
            .then(result => {
              if (result.data && !result.data.error) {
                this.tagsList = result.data.data

              }
            })
    },
    getSubscription(){
      axios .get(`${common.supervisorApi}rest/get_subscription_details`)
          .then(result => {
          
            if (result.data && !result.data.data.error) {
              this.subscription = result.data             
              //console.log(result.data)
              if (result.data.data.subscription_type==0 || result.data.data.subscription_type==-1){ //no active subscription or trial
                if (!result.data.data.trial_used){
                  this.trialActivated=false
                  // Automatically start trial for new users
                  this.activateTrial();
                } else {
                  //console.log(result.data.data.trial_used)
                  if (result.data.data.time_left){
                    this.trialLeftDays=result.data.data.time_left   
                  }
                }
              } else { //do not show if subscription
                this.trialActivated=true
                this.showTrial=false
              }

              if (result.data.data.subscription_type!=8){
                  this.statTotalSpace = result.data.data.limits.max_size_allowed
                  this.statTotalUsers = result.data.data.limits.max_users_allowed
              } else { // admin
                this.statTotalSpace = 1000000000000
                this.statTotalUsers = 100
              }
            }
          })
    },
    onPageChange() {

      this.getModelsList(false)
    },
    getModelsList(afterUpload = false) {
      let data = {}
      if (this.modelName)
        data.filter = this.modelName
      if (this.modelTag)
        data.tag = this.modelTag    
        
      axios .post(`${common.supervisorApi}models/get_models_list/0/${this.page}/${this.perPage}`, data)
            .then(result => {
              this.tableDataLoaded = true;

              if (result.data && !result.data.error && result.data.data && result.data.data.models) {
                this.dataList = result.data.data.models
              } else {
                this.dataList = []
              }

              if (result.data.data.total_size>=0)
                this.statUsedSpace = parseInt(result.data.data.total_size)
              
              if (result.data.data.results>=0)
                this.statNumModels = parseInt(result.data.data.results)

              if(afterUpload)
                this.uploadRequest = false;
                this.loaded = true
            })
    },
    closeUploadWindow() {
      this.getModelsList(true)
    },

    onRowClick(row) {
      this.$router.push(`/model-details/${row.model_id}`)
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    /*searchModel() {

      const data = {
        modelName: this.modelName,
        modelTag: this.modelTag,
        limit:this.limit,
        offset:this.offset
      }
      axios .post(`${common.supervisorApi}models/get_models_list/`, data)
            .then(result => {
              console.log(result.data)
            })
    },*/
    showExportOptions() {
      this.exportOptions = true;
      this.overlay = true;
    },
    exportModels(type) {
      axios .get(`${common.supervisorApi}users/id_from_frontier_table`)
            .then(result => {
              if (result.data && !result.data.error) {
                if (type == 'all')
                  location.href=`${common.documentApi}?userId=${result.data.data.customer_hash}`
                else
                  //location.href=`${common.documentApi}?userId=${result.data.data.customer_hash}&resultsLimit=${this.perPage}`
                  location.href=`${common.documentApi}?userId=${result.data.data.customer_hash}&indexRow=${(this.page-1)*this.perPage}&resultsLimit=${this.perPage}`

                }
                
            });
    },
    applyTemplate() {
      let models = []
      for (let el in this.dataList)
        if (this.dataList[el].checked)
          models.push(this.dataList[el].model_id)
      if (models.length) {
        const data = {
          modelsList : models
        }
        this.$swal({
          title:'Are you sure to apply template to selected models?',
          icon:'warning',
          type:"warning",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: "No"
        }).then(isConfirm => {
          if (isConfirm.isConfirmed)
            axios .post(`${common.supervisorApi}models/apply_template`, data)
                .then(result => {
                  if (result.data && !result.data.error && result.data.data && result.data.data.success)
                    this.$swal.fire('Success', result.data.data.message, 'success');
                  if ( (result.data && result.data.error) || (result.data && !result.data.error && result.data.data && result.data.data.error))
                    this.$swal.fire('Error', 'An error has occurred', 'error')
                })
          
        })

      }
    },
    deleteAll() {

      let models = []
      for (let el in this.dataList)
        if (this.dataList[el].checked)
          models.push(this.dataList[el])
    
      if (models.length){
        this.$swal.fire({
        title:'Are you sure you want to delete these models?',
        icon:'warning',
        type:"warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const data = {
            models:models
            //models:this.dataList
          }
          return axios .post(`${common.supervisorApi}models/bulk_delete_models`, data)
                .then(result => {
                  return result
                })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        }).then((result) => {

          if (result.isConfirmed) {
            if (result.value.data && !result.value.data.error && result.value.data.data.success)
              this.$swal.fire('Success', result.value.data.data.message, 'success');
              this.getModelsList(false)
            if (result.value.data && result.value.data.error)
              this.$swal.fire('Error', result.value.data.data.message, 'error')
            
          }
        })
      }
    },
    checkProductTour(){
      axios .get(`${common.supervisorApi}users/message/nd`)
          .then(result => {
            if (result.data && !result.data.error) {

              if (result.data.data){ //null if no value
                if (result.data.data.message_account_list) {    
                  if (result.data.data.message_account_list==='true'){
                    this.$tours['myTour'].start()
                  } else {
                    this.productTour1Done=true
                    this.checkProductTour2() //the second product tour might still be needed
                  }                
                } else {
                  this.$tours['myTour'].start()
                }
              } else {
                this.$tours['myTour'].start()
              }
            }
          })  
    },
    stopProductTour() {
      axios .get(`${common.supervisorApi}users/message/nd/message_account_list/false`)
            .then(result => {
              if (result.data && !result.data.error) {

                this.productTour1Done=true
                this.checkProductTour2() //execute the second tour when the first one is finished
              }
            })
    },
    checkProductTour2(){
      //if the first product tour has not been completed, then the second product tour has not been completed as well
      if (this.productTour1Done===true){ 
        axios .get(`${common.supervisorApi}users/message/nd`)
            .then(result => {
              if (result.data && !result.data.error) {

                if (result.data.data){ //null if no value
                  if (result.data.data.message_account_model) {    
                    if (result.data.data.message_account_model==='true'){                     
                      if (Object.keys(this.dataList).length>0){
                        this.$tours['myTour2'].start()
                      }
                    }                
                  } else {
                    if (Object.keys(this.dataList).length>0){
                      this.$tours['myTour2'].start()
                    }
                  }
                } else {
                  if (Object.keys(this.dataList).length>0){
                    this.$tours['myTour2'].start()
                  }
                }
              }
            }) 
      } 
    },
    stopProductTour2() {
      axios .get(`${common.supervisorApi}users/message/nd/message_account_model/false`)
            .then(result => {
              if (result.data && !result.data.error) {
                //console.log(result.data) -- leave here, cancel can cause a build error
              }
            })
    },
    getTime(){
      return new Date().getTime()
    },
    activateTrial(){
      axios .get(`${common.supervisorApi}subscriptions/start_trial_period`)
            .then(result => {

              if (result.data && !result.data.error) {
                this.trialActivated=true
                this.trialLeftDays = 14
                this.getSubscription()
                //this.$gtm.push(['trackEvent', 'account', 'click', 'trial'])
                //this._paq.push(['trackEvent', 'account', 'click', 'trial']);
                if (this.$gtm.enabled()) {                            
                  window.dataLayer?.push({
                    'event' : 'trialActivated'
                  });
                }                
              }
            })
    },
    onContextMenu(e,data) {      
      e.preventDefault()
      //Show component mode menu
      this.showContextMenu = true
      this.optionsContextMenu.x = e.x
      this.optionsContextMenu.y = e.y
      this.modelDataContextMenu = data
      this.fileExt = data.modelName.toLowerCase().split('.').pop()
      //console.log(data)
    },
    onMenuClick(modelData){
      navigator.clipboard.writeText(modelData.url)
      //console.log(modelData.url)
    },
    // onMenuClickComments(modelData){
    //   if (this.$gtm.enabled()) {                            
    //     window.dataLayer?.push({
    //     'event' : 'openComments'
    //   })}   
    //   window.open(modelData.url+'?comments=true', '_blank')
    // },
    onMenuClickEdit(modelData){
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openSettings'
      })}        
      window.open(modelData.url+'?settings=true', '_blank')
    },
    onMenuClickView(modelData){
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openViewer'
      })}  
      //window.open(modelData.url, '_blank')
      window.open(modelData.url+'?comments=true', '_blank')
    },
    toggleSpaceView() {
      this.showSpaceInPercentage = !this.showSpaceInPercentage;
    }
  }
}
</script>
